import React from 'react';
import { connect } from 'react-redux';
import FocusTrap from '@s/FocusTrap';
import Page from 'shared/Page';
import InventoryItemsContainer from '../../ticket-picker/containers/InventoryItemsContainer';
import { getDynamicListingSettings } from '../../../selectors/ui';
import InventoryContentContainer from '../../ticket-picker/containers/InventoryContentContainer';
import CheckoutButton from '../../ticket-picker/containers/CheckoutButton';
import CouponEntryButton from '../../ticket-picker/containers/CouponEntryButton';
import InventoryErrors from '../../ticket-picker/containers/InventoryErrors';
import AlertContainer from '../../cart/containers/AlertContainer';
import ListingDetails from '@b/listing/components/ListingDetails';
import ListingBanner from '@b/listing/components/ListingBanner';
import TicketsButtonContainer from '@b/checkout/containers/TicketsButtonContainer';
import ContactInfo from '@b/listing/components/ContactInfo';
import TicketPickerContainer from '@v/ticket-picker/containers/TicketPickerContainer';
import CouponAlertsContainer from '@v/ticket-picker/containers/CouponAlertsContainer';
import InventoryFooterContainer from '@v/ticket-picker/containers/InventoryFooterContainer';
import FeeDisclosure from '@v/ticket-picker/containers/FeeDisclosure';
import MemberAuthButtons from '@b/checkout/components/MemberAuthButtons';
import { VenueInfo } from '@b/listing/components/VenueInfo';
import { PageContentWithTabs } from '@b/listing/components/PageContentWithTabs';
import SeriesDatePicker from '@v/series/components/SeriesDatePicker';
import ListingEventDetails from '@b/listing/components/ListingEventDetails';
import BestAvailableOrPyosPicker from '@v/reserved-seating/containers/BestAvailableOrPyosPicker';
import SeatingChartTicketPickerContainer from '@v/reserved-seating/containers/SeatingChartTicketPickerContainer';
import InventoryHeaderContainer from '@v/ticket-picker/containers/InventoryHeaderContainer';
import DynamicTicketsHeader from './DynamicTicketsHeader';
import { isSeatedListing, showPyosPicker } from '@b/checkout/selectors/reserved-seating';

class DynamicListingPage extends Page {

  map = {
    AlertContainer: AlertContainer,
    CheckoutButton,
    contactInfo: ContactInfo,
    CouponAlertsContainer,
    CouponEntryButton,
    PageContentWithTabs,
    FeeDisclosure,
    InventoryContentContainer,
    InventoryErrors,
    InventoryFooterContainer,
    InventoryItemsContainer,
    listingBanner: ListingBanner,
    listingDetails: ListingDetails,
    memberAuthButtons: MemberAuthButtons,
    TicketPickerContainer,
    SeriesDatePicker,
    ticketsButton: TicketsButtonContainer,
    VenueInfo,
    ListingEventDetails,
    BestAvailableOrPyosPicker,
    SeatingChartTicketPickerContainer,
    InventoryHeaderContainer,
    DynamicTicketsHeader,
  }

  render() {
    const className = this.props?.isSeated && this.props?.isShowPyosPicker ? 'dynamic-listing-wrap--full-width' : '';

    return (
      <FocusTrap fallback=".dynamic-listing-wrap">
        <div className={`dynamic-listing-wrap ${className}`} aria-modal="true" tabIndex="-1">
          <main id="page">
            {this.getComponents()}
          </main>
        </div>
      </FocusTrap>
    );
  }
}

const mapStateToProps = (state, props) => ({
  settings: getDynamicListingSettings(state, props),
  isSeated: isSeatedListing(state),
  isShowPyosPicker: showPyosPicker(state),
})

export default connect(mapStateToProps)(DynamicListingPage);
